import { render } from "./BrandCard.vue?vue&type=template&id=a9ab98fe"
import script from "./BrandCard.vue?vue&type=script&lang=js"
export * from "./BrandCard.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__